// RepeatableForm.js

import { MdDelete } from "react-icons/md";
import { Container, Draggable } from "react-smooth-dnd";
import FormField from "./FormField";
// formatFormTemplateField import'una artık burada gerek yok.

const RepeatableForm = ({
  translate,
  formIndex,
  index, // Bu, RepeatableForm'un SubForm içindeki kendi index'i
  formTemplate,
  setFormTemplate,
  field,
  selectedField,
  setSelectedField,
  isEditing,
  // YENİ PROP: Parent'taki onDrop fonksiyonunu tetiklemek için
  onDropInRepeatable,
  getGhostParent,
}) => {
  // onDrop fonksiyonu buradan tamamen kaldırıldı.

  const handleRemoveRepeatable = () => {
    const newFormTemplate = [...formTemplate];
    newFormTemplate[formIndex].fields.splice(index, 1);
    setFormTemplate(newFormTemplate);
  };

  return (
    <>
      <div className="form-field-header drag-trigger">
        <h3 className="form-field-title text-uppercase m-0">
          {isEditing && (
            <MdDelete
              className="fs-5 me-2 mb-1 cursor--pointer"
              onClick={handleRemoveRepeatable}
            />
          )}
          {translate("form_fields.repeatable")}
        </h3>
      </div>

      <div className="form-field-body" data-is-repeatable={true}>
        <Container
          dragHandleSelector={
            isEditing ? ".drag-trigger" : ".no-drag-available"
          }
          groupName={`field-${formIndex}`}
          lockAxis="y"
          dragClass="cursor--grabbing"
          getGhostParent={getGhostParent}
          // DEĞİŞİKLİK: Parent'a index yerine field.id gönderiyoruz.
          onDrop={(dropResult) => onDropInRepeatable(dropResult, field.id)}
          shouldAcceptDrop={(sourceContainerOptions, payload) => {
            return !payload.isRepeatable && payload.fieldType !== "repeatable";
          }}
          getChildPayload={(childIndex) => ({
            ...field.repeatedFields[childIndex],
            source: "repeatable",
            // Index yerine, bu Repeatable alanın kendi sabit ID'sini gönderiyoruz.
            sourceRepeatableId: field.id,
          })}
        >
          {field.repeatedFields.map((repeatableField, i) => (
            <Draggable key={repeatableField.id || i}>
              <FormField
                translate={translate}
                field={repeatableField}
                repeatedFieldIndex={i}
                fieldIndex={index}
                formIndex={formIndex}
                selectedField={selectedField}
                setSelectedField={setSelectedField}
                isEditing={isEditing}
                formTemplate={formTemplate}
                setFormTemplate={setFormTemplate}
              />
            </Draggable>
          ))}
        </Container>
      </div>
    </>
  );
};

export default RepeatableForm;